export function answerStatusToDisplayText(status: AnswerStatus): string {
  switch (status) {
    case AnswerStatus.NotRegistered:
      return "Not Registered";
    case AnswerStatus.NotStarted:
      return "Not Started";
    case AnswerStatus.InProgress:
      return "In Progress";
    case AnswerStatus.Completed:
      return "Completed";
    default:
      return "";
  }
}

export enum AnswerStatus {
  NotRegistered = "NOT_REGISTERED",
  NotStarted = "NOT_STARTED",
  InProgress = "IN_PROGRESS",
  Completed = "COMPLETED",
}
